import { create } from "zustand";
import { DomainStoreTypes } from "./storeTypes/domainStoreTypes";
import { DomainTypes } from "../interfaces/domain.interface";

const useDomainStore = create<DomainStoreTypes>((set) => ({
        subjects: [],
        setSubjects: (data:Array<DomainTypes>)=>set(()=>({subjects:data})),
        complexity:[],
        marks: [],
        setMarks:  (data:Array<DomainTypes>)=>set(()=>({marks:data})),
        setComplexity:  (data:Array<DomainTypes>)=>set(()=>({complexity:data})),
        language:[],
        setLanguage:  (data:Array<DomainTypes>)=>set(()=>({language:data})) 
}));


export   default useDomainStore